import times from 'lodash/times';
import map from 'lodash/map';

import templateUrl from './subcategory-information.html'

export const subcategoryInformationComponent = {
    bindings: {
        details: '<',
        isRequired: '@',
        subCategoryList: '<',
        onSubmit: '&',
        onCancel: '&'
    },
    templateUrl,
    controller: class SubcategoryInformationComponent {
        constructor($filter, $scope) {
            'ngInject';
            this.$filter = $filter;
            this.$scope = $scope;
        }
        $onInit() {
            this.subcategoryNameError= false;
            this.addressError = false;
            this.phoneNumberError = false;

            this.address = {
                addressLine1: "",
                addressLine2: "",
                cityName: "",
                stateName: "",
                stateCode: "",
                latlng: {},
                zipcode: "",
                status: -1
            };

            this.phoneNumber = {
                value: '',
                ext: '',
                status: ''
            };
            this.details = this.details || [];
            this.categoryForm = 2;
            if (this.details && this.details.length > 0) {

            } else {
                this.details = this._getEmptySubCategoty(this.categoryForm);
            }

        }

        onAddNewSubCategory() {
            this.categoryForm++;
            this.details = this.details.concat(this._getEmptySubCategoty(1));
        }
        _getEmptySubCategoty(subcategory) {
            return this._repeatObject(subcategory);
        }

        onAddressChange(event, parentIndex, index) {
            this.details[parentIndex].address[index] = event;
        }
        _getContentDetails(details, index) {
            if (!details) {
                details = {};
            }

            return {
                name: details.name || '',
                id: details.id || '',
                phoneNumbers: details.phoneNumber || [Object.assign({}, this.phoneNumber)],
                address: details.address || [this.address]
            }

        }
        getFormattedAddress(address) {
            if (address) {
                let addressDetails = [address.addressLine1];
                if (address.addressLine2) {
                    addressDetails.push(address.addressLine2);
                }
                addressDetails.push(address.cityName);
                addressDetails.push(address.zipcode ? `${address.stateName} ${address.zipcode}` : address.stateName);
                return addressDetails.join(', ');
            }
            return "";
        }

        _addAnotherAddress(index) {
            this.details[index].address.push(this.address);
        }


        _repeatObject(times) {
            let data = [];
            while (times > 0) {
                data.push(this._getContentDetails(this.details));
                times--;
            }
            return data;
        }

        _get() {
            return this.details.map((value) => {
                let obj = {
                    name: value.name,
                    address: value.address,
                    phoneNumbers: value.phoneNumbers
                }
                return obj;
            })
        }

        _getErrorMsg(details) {
            this.subcategoryNameError = false;
            this.addressError = false;
            this.phoneNumberError = false;
            details.map(value => {
                if (value.name === "" || value.name.trim() === "") {
                    this.subcategoryNameError = true;
                }
                value.address.map(address => {
                    if(address.addressLine1 === ""){
                        this.addressError = true;
                    }
                });
                value.phoneNumbers.map(number => {
                    if(number.value === ""){
                        this.phoneNumberError = true;
                    }
                })
                if(value.phoneNumbers.value === ""){
                    this.phoneNumberError = true;
                }

            });
        }

        _onSubmit() {
            const details = this._get.call(this);
            this._getErrorMsg(details);
            if(this.subcategoryNameError === false && this.addressError === false && this.phoneNumberError === false){
                this.onSubmit({
                    $event: {
                        details: details
                    }
    
                });
            }
            
        }
        

        _onCancel() {
            const details = this._get.call(this);
            this.onCancel({
                $event: {
                    details: details
                }
            });
        }

        onAdd(index) {

            this.details[index].phoneNumbers.push(this.phoneNumber);
        }

    }

}


// WEBPACK FOOTER //
// ./src/app/components/resources/subcategory-information/subcategory-information.component.js